// 2022 House Election Results Data
// Source: MIT Election Lab
// 213 Democratic seats, 222 Republican seats

export const houseResults2022 = [
  {
    state: "Alaska",
    district: "AL",
    demCandidate: "Mary Sattler Peltola",
    demVotes: 128553,
    repCandidate: "Sarah Palin",
    repVotes: 67866,
    totalVotes: 196419,
    winner: "D"
  },
  {
    state: "Alabama",
    district: "1",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Jerry L Carl",
    repVotes: 140592,
    totalVotes: 140592,
    winner: "R"
  },
  {
    state: "Alabama",
    district: "2",
    demCandidate: "Phyllis Harvey-Hall",
    demVotes: 58014,
    repCandidate: "Barry Moore",
    repVotes: 137460,
    totalVotes: 195474,
    winner: "R"
  },
  {
    state: "Alabama",
    district: "3",
    demCandidate: "Lin Veasey",
    demVotes: 47859,
    repCandidate: "Mike Rogers",
    repVotes: 135602,
    totalVotes: 183461,
    winner: "R"
  },
  {
    state: "Alabama",
    district: "4",
    demCandidate: "Rick Neighbors",
    demVotes: 26694,
    repCandidate: "Robert B Aderholt",
    repVotes: 164655,
    totalVotes: 191349,
    winner: "R"
  },
  {
    state: "Alabama",
    district: "5",
    demCandidate: "Kathy Warner-Stanton",
    demVotes: 62740,
    repCandidate: "Dale Strong",
    repVotes: 142435,
    totalVotes: 205175,
    winner: "R"
  },
  {
    state: "Alabama",
    district: "6",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Gary J Palmer",
    repVotes: 154233,
    totalVotes: 154233,
    winner: "R"
  },
  {
    state: "Alabama",
    district: "7",
    demCandidate: "Terri A Sewell",
    demVotes: 123233,
    repCandidate: "Beatrice Nichols",
    repVotes: 67416,
    totalVotes: 190649,
    winner: "D"
  },
  {
    state: "Arkansas",
    district: "1",
    demCandidate: "Monte Hodges",
    demVotes: 54598,
    repCandidate: "Eric A  Crawford",
    repVotes: 153774,
    totalVotes: 208372,
    winner: "R"
  },
  {
    state: "Arkansas",
    district: "2",
    demCandidate: "Quintessa Hathaway",
    demVotes: 86887,
    repCandidate: "J French Hill",
    repVotes: 147975,
    totalVotes: 234862,
    winner: "R"
  },
  {
    state: "Arkansas",
    district: "3",
    demCandidate: "Lauren Mallett-Hays",
    demVotes: 73541,
    repCandidate: "Steve Womack",
    repVotes: 142401,
    totalVotes: 215942,
    winner: "R"
  },
  {
    state: "Arkansas",
    district: "4",
    demCandidate: "John White",
    demVotes: 56745,
    repCandidate: "Bruce Westerman",
    repVotes: 153850,
    totalVotes: 210595,
    winner: "R"
  },
  {
    state: "Arizona",
    district: "1",
    demCandidate: "Jevin Hodge",
    demVotes: 179141,
    repCandidate: "David Schweikert",
    repVotes: 182336,
    totalVotes: 361477,
    winner: "R"
  },
  {
    state: "Arizona",
    district: "2",
    demCandidate: "Tom O\"Halleran",
    demVotes: 149151,
    repCandidate: "Eli Crane",
    repVotes: 174169,
    totalVotes: 323320,
    winner: "R"
  },
  {
    state: "Arizona",
    district: "3",
    demCandidate: "Ruben Gallego",
    demVotes: 108599,
    repCandidate: "Jeff Zink",
    repVotes: 32475,
    totalVotes: 141074,
    winner: "D"
  },
  {
    state: "Arizona",
    district: "4",
    demCandidate: "Greg Stanton",
    demVotes: 148941,
    repCandidate: "Kelly Cooper",
    repVotes: 116521,
    totalVotes: 265462,
    winner: "D"
  },
  {
    state: "Arizona",
    district: "5",
    demCandidate: "Javier Ramos",
    demVotes: 120243,
    repCandidate: "Andy Biggs",
    repVotes: 182464,
    totalVotes: 302707,
    winner: "R"
  },
  {
    state: "Arizona",
    district: "6",
    demCandidate: "Kirsten Engel",
    demVotes: 171969,
    repCandidate: "Juan Ciscomani",
    repVotes: 177201,
    totalVotes: 349170,
    winner: "R"
  },
  {
    state: "Arizona",
    district: "7",
    demCandidate: "RaãL M Grijalva",
    demVotes: 126418,
    repCandidate: "Luis Pozzolo",
    repVotes: 69444,
    totalVotes: 195862,
    winner: "D"
  },
  {
    state: "Arizona",
    district: "8",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Debbie Lesko",
    repVotes: 197555,
    totalVotes: 197555,
    winner: "R"
  },
  {
    state: "Arizona",
    district: "9",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Paul Gosar",
    repVotes: 192796,
    totalVotes: 192796,
    winner: "R"
  },
  {
    state: "California",
    district: "1",
    demCandidate: "Max Steiner",
    demVotes: 93386,
    repCandidate: "Doug LaMalfa",
    repVotes: 152839,
    totalVotes: 246225,
    winner: "R"
  },
  {
    state: "California",
    district: "2",
    demCandidate: "Jared Huffman",
    demVotes: 229720,
    repCandidate: "Douglas Brower",
    repVotes: 79029,
    totalVotes: 308749,
    winner: "D"
  },
  {
    state: "California",
    district: "3",
    demCandidate: "Kermit Jones",
    demVotes: 156761,
    repCandidate: "Kevin Kiley",
    repVotes: 181438,
    totalVotes: 338199,
    winner: "R"
  },
  {
    state: "California",
    district: "4",
    demCandidate: "Mike Thompson",
    demVotes: 176900,
    repCandidate: "Matt Brock",
    repVotes: 84007,
    totalVotes: 260907,
    winner: "D"
  },
  {
    state: "California",
    district: "5",
    demCandidate: "Michael J  Barkley",
    demVotes: 109506,
    repCandidate: "Tom McClintock",
    repVotes: 173524,
    totalVotes: 283030,
    winner: "R"
  },
  {
    state: "California",
    district: "6",
    demCandidate: "Ami Bera",
    demVotes: 121058,
    repCandidate: "Tamika Hamilton",
    repVotes: 95325,
    totalVotes: 216383,
    winner: "D"
  },
  {
    state: "California",
    district: "7",
    demCandidate: "Doris O Matsui",
    demVotes: 150618,
    repCandidate: "Max Semenenko",
    repVotes: 70033,
    totalVotes: 220651,
    winner: "D"
  },
  {
    state: "California",
    district: "8",
    demCandidate: "John Garamendi",
    demVotes: 145501,
    repCandidate: "Rudy Recile",
    repVotes: 46634,
    totalVotes: 192135,
    winner: "D"
  },
  {
    state: "California",
    district: "9",
    demCandidate: "Josh Harder",
    demVotes: 95598,
    repCandidate: "Tom Patti",
    repVotes: 78802,
    totalVotes: 174400,
    winner: "D"
  },
  {
    state: "California",
    district: "10",
    demCandidate: "Mark DeSaulnier",
    demVotes: 198415,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 198415,
    winner: "D"
  },
  {
    state: "California",
    district: "11",
    demCandidate: "Nancy Pelosi",
    demVotes: 220848,
    repCandidate: "John Dennis",
    repVotes: 42217,
    totalVotes: 263065,
    winner: "D"
  },
  {
    state: "California",
    district: "12",
    demCandidate: "Barbara Lee",
    demVotes: 217110,
    repCandidate: "Stephen Slauson",
    repVotes: 22859,
    totalVotes: 239969,
    winner: "D"
  },
  {
    state: "California",
    district: "13",
    demCandidate: "Adam Gray",
    demVotes: 66496,
    repCandidate: "John Duarte",
    repVotes: 67060,
    totalVotes: 133556,
    winner: "R"
  },
  {
    state: "California",
    district: "14",
    demCandidate: "Eric Swalwell",
    demVotes: 137612,
    repCandidate: "Alison Hayden",
    repVotes: 60852,
    totalVotes: 198464,
    winner: "D"
  },
  {
    state: "California",
    district: "15",
    demCandidate: "Kevin Mullin",
    demVotes: 108077,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 108077,
    winner: "D"
  },
  {
    state: "California",
    district: "16",
    demCandidate: "Anna G Eshoo",
    demVotes: 139235,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 139235,
    winner: "D"
  },
  {
    state: "California",
    district: "17",
    demCandidate: "Ro Khanna",
    demVotes: 127853,
    repCandidate: "Ritesh Tandon",
    repVotes: 52400,
    totalVotes: 180253,
    winner: "D"
  },
  {
    state: "California",
    district: "18",
    demCandidate: "Zoe Lofgren",
    demVotes: 99776,
    repCandidate: "Peter Hernandez",
    repVotes: 51737,
    totalVotes: 151513,
    winner: "D"
  },
  {
    state: "California",
    district: "19",
    demCandidate: "Jimmy Panetta",
    demVotes: 194494,
    repCandidate: "Jeff Gorman",
    repVotes: 88816,
    totalVotes: 283310,
    winner: "D"
  },
  {
    state: "California",
    district: "20",
    demCandidate: "Marisa Wood",
    demVotes: 74934,
    repCandidate: "Kevin McCarthy",
    repVotes: 153847,
    totalVotes: 228781,
    winner: "R"
  },
  {
    state: "California",
    district: "21",
    demCandidate: "Jim Costa",
    demVotes: 68074,
    repCandidate: "Michael Maher",
    repVotes: 57573,
    totalVotes: 125647,
    winner: "D"
  },
  {
    state: "California",
    district: "22",
    demCandidate: "Rudy Salas",
    demVotes: 49862,
    repCandidate: "David G Valadao",
    repVotes: 52994,
    totalVotes: 102856,
    winner: "R"
  },
  {
    state: "California",
    district: "23",
    demCandidate: "Derek Marshall",
    demVotes: 65908,
    repCandidate: "Jay Obernolte",
    repVotes: 103197,
    totalVotes: 169105,
    winner: "R"
  },
  {
    state: "California",
    district: "24",
    demCandidate: "Salud O Carbajal",
    demVotes: 159019,
    repCandidate: "Brad Allen",
    repVotes: 103533,
    totalVotes: 262552,
    winner: "D"
  },
  {
    state: "California",
    district: "25",
    demCandidate: "Raul Ruiz",
    demVotes: 87641,
    repCandidate: "Brian E Hawkins",
    repVotes: 65101,
    totalVotes: 152742,
    winner: "D"
  },
  {
    state: "California",
    district: "26",
    demCandidate: "Julia Brownley",
    demVotes: 134575,
    repCandidate: "Matt Jacobs",
    repVotes: 112214,
    totalVotes: 246789,
    winner: "D"
  },
  {
    state: "California",
    district: "27",
    demCandidate: "Christy Smith",
    demVotes: 91892,
    repCandidate: "Mike Garcia",
    repVotes: 104624,
    totalVotes: 196516,
    winner: "R"
  },
  {
    state: "California",
    district: "28",
    demCandidate: "Judy Chu",
    demVotes: 150062,
    repCandidate: "Wes Hallman",
    repVotes: 76495,
    totalVotes: 226557,
    winner: "D"
  },
  {
    state: "California",
    district: "29",
    demCandidate: "Tony CãRdenas",
    demVotes: 69915,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 69915,
    winner: "D"
  },
  {
    state: "California",
    district: "30",
    demCandidate: "Adam B Schiff",
    demVotes: 150100,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 150100,
    winner: "D"
  },
  {
    state: "California",
    district: "31",
    demCandidate: "Grace F Napolitano",
    demVotes: 91472,
    repCandidate: "Daniel Bocic Martinez",
    repVotes: 62153,
    totalVotes: 153625,
    winner: "D"
  },
  {
    state: "California",
    district: "32",
    demCandidate: "Brad Sherman",
    demVotes: 167411,
    repCandidate: "Lucie Lapointe Volotzky",
    repVotes: 74618,
    totalVotes: 242029,
    winner: "D"
  },
  {
    state: "California",
    district: "33",
    demCandidate: "Pete Aguilar",
    demVotes: 76588,
    repCandidate: "John Mark Porter",
    repVotes: 56119,
    totalVotes: 132707,
    winner: "D"
  },
  {
    state: "California",
    district: "34",
    demCandidate: "Jimmy Gomez",
    demVotes: 62244,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 62244,
    winner: "D"
  },
  {
    state: "California",
    district: "35",
    demCandidate: "Norma J Torres",
    demVotes: 75121,
    repCandidate: "Mike Cargile",
    repVotes: 55832,
    totalVotes: 130953,
    winner: "D"
  },
  {
    state: "California",
    district: "36",
    demCandidate: "Ted Lieu",
    demVotes: 194299,
    repCandidate: "Joe E Collins III",
    repVotes: 84264,
    totalVotes: 278563,
    winner: "D"
  },
  {
    state: "California",
    district: "37",
    demCandidate: "Sydney Kamlager",
    demVotes: 84338,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 84338,
    winner: "D"
  },
  {
    state: "California",
    district: "38",
    demCandidate: "Linda T SãNchez",
    demVotes: 101260,
    repCandidate: "Eric J Ching",
    repVotes: 73051,
    totalVotes: 174311,
    winner: "D"
  },
  {
    state: "California",
    district: "39",
    demCandidate: "Mark Takano",
    demVotes: 75896,
    repCandidate: "Aja Smith",
    repVotes: 55701,
    totalVotes: 131597,
    winner: "D"
  },
  {
    state: "California",
    district: "40",
    demCandidate: "Asif Mahmood",
    demVotes: 122722,
    repCandidate: "Young Kim",
    repVotes: 161589,
    totalVotes: 284311,
    winner: "R"
  },
  {
    state: "California",
    district: "41",
    demCandidate: "Will Rollins",
    demVotes: 112769,
    repCandidate: "Ken Calvert",
    repVotes: 123869,
    totalVotes: 236638,
    winner: "R"
  },
  {
    state: "California",
    district: "42",
    demCandidate: "Robert Garcia",
    demVotes: 99217,
    repCandidate: "John Briscoe",
    repVotes: 45903,
    totalVotes: 145120,
    winner: "D"
  },
  {
    state: "California",
    district: "43",
    demCandidate: "Maxine Waters",
    demVotes: 95462,
    repCandidate: "Omar Navarro",
    repVotes: 27985,
    totalVotes: 123447,
    winner: "D"
  },
  {
    state: "California",
    district: "44",
    demCandidate: "Nanette Diaz BarragãN",
    demVotes: 100160,
    repCandidate: "Paul Jones",
    repVotes: 38554,
    totalVotes: 138714,
    winner: "D"
  },
  {
    state: "California",
    district: "45",
    demCandidate: "Jay F Chen",
    demVotes: 103466,
    repCandidate: "Michelle Steel",
    repVotes: 113960,
    totalVotes: 217426,
    winner: "R"
  },
  {
    state: "California",
    district: "46",
    demCandidate: "J Luis Correa",
    demVotes: 78041,
    repCandidate: "Christopher J Gonzales",
    repVotes: 48257,
    totalVotes: 126298,
    winner: "D"
  },
  {
    state: "California",
    district: "47",
    demCandidate: "Katie Porter",
    demVotes: 137374,
    repCandidate: "Scott Baugh",
    repVotes: 128261,
    totalVotes: 265635,
    winner: "D"
  },
  {
    state: "California",
    district: "48",
    demCandidate: "Stephen Houlahan",
    demVotes: 101900,
    repCandidate: "Darrell Issa",
    repVotes: 155171,
    totalVotes: 257071,
    winner: "R"
  },
  {
    state: "California",
    district: "49",
    demCandidate: "Mike Levin",
    demVotes: 153541,
    repCandidate: "Brian Maryott",
    repVotes: 138194,
    totalVotes: 291735,
    winner: "D"
  },
  {
    state: "California",
    district: "50",
    demCandidate: "Scott H Peters",
    demVotes: 168816,
    repCandidate: "Corey Gustafson",
    repVotes: 99819,
    totalVotes: 268635,
    winner: "D"
  },
  {
    state: "California",
    district: "51",
    demCandidate: "Sara Jacobs",
    demVotes: 144186,
    repCandidate: "Stan Caplan",
    repVotes: 88886,
    totalVotes: 233072,
    winner: "D"
  },
  {
    state: "California",
    district: "52",
    demCandidate: "Juan Vargas",
    demVotes: 100686,
    repCandidate: "Tyler Geffeney",
    repVotes: 50330,
    totalVotes: 151016,
    winner: "D"
  },
  {
    state: "Colorado",
    district: "1",
    demCandidate: "Diana Degette",
    demVotes: 226929,
    repCandidate: "Jennifer Qualteri",
    repVotes: 49530,
    totalVotes: 276459,
    winner: "D"
  },
  {
    state: "Colorado",
    district: "2",
    demCandidate: "Joe Neguse",
    demVotes: 244107,
    repCandidate: "Marshall Dawson",
    repVotes: 97700,
    totalVotes: 341807,
    winner: "D"
  },
  {
    state: "Colorado",
    district: "3",
    demCandidate: "Adam Frisch",
    demVotes: 163293,
    repCandidate: "Lauren Boebert",
    repVotes: 163839,
    totalVotes: 327132,
    winner: "R"
  },
  {
    state: "Colorado",
    district: "4",
    demCandidate: "Ike Mccorkle",
    demVotes: 129619,
    repCandidate: "Ken Buck",
    repVotes: 216024,
    totalVotes: 345643,
    winner: "R"
  },
  {
    state: "Colorado",
    district: "5",
    demCandidate: "David Torres",
    demVotes: 111978,
    repCandidate: "Doug Lamborn",
    repVotes: 155528,
    totalVotes: 267506,
    winner: "R"
  },
  {
    state: "Colorado",
    district: "6",
    demCandidate: "Jason Crow",
    demVotes: 170140,
    repCandidate: "Steven Monahan",
    repVotes: 105084,
    totalVotes: 275224,
    winner: "D"
  },
  {
    state: "Colorado",
    district: "7",
    demCandidate: "Brittany Pettersen",
    demVotes: 204984,
    repCandidate: "Erik Aadland",
    repVotes: 150510,
    totalVotes: 355494,
    winner: "D"
  },
  {
    state: "Colorado",
    district: "8",
    demCandidate: "Yadira Caraveo",
    demVotes: 114377,
    repCandidate: "Barbara Kirkmeyer",
    repVotes: 112745,
    totalVotes: 227122,
    winner: "D"
  },
  {
    state: "Connecticut",
    district: "1",
    demCandidate: "John B Larson",
    demVotes: 144873,
    repCandidate: "Larry Lazor",
    repVotes: 91506,
    totalVotes: 236379,
    winner: "D"
  },
  {
    state: "Connecticut",
    district: "2",
    demCandidate: "Joe Courtney",
    demVotes: 165946,
    repCandidate: "Mike France",
    repVotes: 114506,
    totalVotes: 280452,
    winner: "D"
  },
  {
    state: "Connecticut",
    district: "3",
    demCandidate: "Rosa L DeLauro",
    demVotes: 137924,
    repCandidate: "Lesley Denardis",
    repVotes: 98704,
    totalVotes: 236628,
    winner: "D"
  },
  {
    state: "Connecticut",
    district: "4",
    demCandidate: "James A Himes",
    demVotes: 140262,
    repCandidate: "Jayme Stevenson",
    repVotes: 93329,
    totalVotes: 233591,
    winner: "D"
  },
  {
    state: "Connecticut",
    district: "5",
    demCandidate: "Jahana Hayes",
    demVotes: 123818,
    repCandidate: "George Logan",
    repVotes: 123342,
    totalVotes: 247160,
    winner: "D"
  },
  {
    state: "Delaware",
    district: "AL",
    demCandidate: "Lisa Blunt Rochester",
    demVotes: 178416,
    repCandidate: "Lee Murphy",
    repVotes: 138201,
    totalVotes: 316617,
    winner: "D"
  },
  {
    state: "Florida",
    district: "1",
    demCandidate: "Rebekah Jones",
    demVotes: 93467,
    repCandidate: "Matt Gaetz",
    repVotes: 197349,
    totalVotes: 290816,
    winner: "R"
  },
  {
    state: "Florida",
    district: "2",
    demCandidate: "Al Lawson, Jr",
    demVotes: 121153,
    repCandidate: "Neal P Dunn",
    repVotes: 180236,
    totalVotes: 301389,
    winner: "R"
  },
  {
    state: "Florida",
    district: "3",
    demCandidate: "Danielle Hawk",
    demVotes: 103382,
    repCandidate: "Kat Cammack",
    repVotes: 178101,
    totalVotes: 281483,
    winner: "R"
  },
  {
    state: "Florida",
    district: "4",
    demCandidate: "Lashonda  Holloway",
    demVotes: 108402,
    repCandidate: "Aaron Bean",
    repVotes: 165696,
    totalVotes: 274098,
    winner: "R"
  },
  {
    state: "Florida",
    district: "5",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "John H Rutherford",
    repVotes: 1,
    totalVotes: 1,
    winner: "R"
  },
  {
    state: "Florida",
    district: "6",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Michael Waltz",
    repVotes: 226548,
    totalVotes: 226548,
    winner: "R"
  },
  {
    state: "Florida",
    district: "7",
    demCandidate: "Karen Green",
    demVotes: 126079,
    repCandidate: "Cory Mills",
    repVotes: 177966,
    totalVotes: 304045,
    winner: "R"
  },
  {
    state: "Florida",
    district: "8",
    demCandidate: "Joanne Terry",
    demVotes: 120080,
    repCandidate: "Bill Posey",
    repVotes: 222128,
    totalVotes: 342208,
    winner: "R"
  },
  {
    state: "Florida",
    district: "9",
    demCandidate: "Darren Soto",
    demVotes: 108541,
    repCandidate: "Scotty Moore",
    repVotes: 93827,
    totalVotes: 202368,
    winner: "D"
  },
  {
    state: "Florida",
    district: "10",
    demCandidate: "Maxwell Alejandro Frost",
    demVotes: 117955,
    repCandidate: "Calvin B Wimbish",
    repVotes: 78844,
    totalVotes: 196799,
    winner: "D"
  },
  {
    state: "Florida",
    district: "11",
    demCandidate: "Shante Munns",
    demVotes: 115647,
    repCandidate: "Daniel Webster",
    repVotes: 205995,
    totalVotes: 321642,
    winner: "R"
  },
  {
    state: "Florida",
    district: "12",
    demCandidate: "Kimberly Walker",
    demVotes: 95390,
    repCandidate: "Gus M Bilirakis",
    repVotes: 226601,
    totalVotes: 321991,
    winner: "R"
  },
  {
    state: "Florida",
    district: "13",
    demCandidate: "Eric Lynn",
    demVotes: 153876,
    repCandidate: "Anna Paulina Luna",
    repVotes: 181487,
    totalVotes: 335363,
    winner: "R"
  },
  {
    state: "Florida",
    district: "14",
    demCandidate: "Kathy Castor",
    demVotes: 149737,
    repCandidate: "James Judge",
    repVotes: 113427,
    totalVotes: 263164,
    winner: "D"
  },
  {
    state: "Florida",
    district: "15",
    demCandidate: "Alan M Cohn",
    demVotes: 102835,
    repCandidate: "Laurel Lee",
    repVotes: 145219,
    totalVotes: 248054,
    winner: "R"
  },
  {
    state: "Florida",
    district: "16",
    demCandidate: "Jan Schneider",
    demVotes: 115575,
    repCandidate: "Vern Buchanan",
    repVotes: 189762,
    totalVotes: 305337,
    winner: "R"
  },
  {
    state: "Florida",
    district: "17",
    demCandidate: "Andrea Doria Kale",
    demVotes: 123798,
    repCandidate: "W Gregory Steube",
    repVotes: 222483,
    totalVotes: 346281,
    winner: "R"
  },
  {
    state: "Florida",
    district: "18",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "C Scott Franklin",
    repVotes: 167429,
    totalVotes: 167429,
    winner: "R"
  },
  {
    state: "Florida",
    district: "19",
    demCandidate: "Cindy Banyai",
    demVotes: 100226,
    repCandidate: "Byron Donalds",
    repVotes: 213035,
    totalVotes: 313261,
    winner: "R"
  },
  {
    state: "Florida",
    district: "20",
    demCandidate: "Sheila Cherfilus-McCormick",
    demVotes: 136215,
    repCandidate: "Drew Montez Clark",
    repVotes: 52151,
    totalVotes: 188366,
    winner: "D"
  },
  {
    state: "Florida",
    district: "21",
    demCandidate: "Corinna Balderramos Robinson",
    demVotes: 119891,
    repCandidate: "Brian J Mast",
    repVotes: 208614,
    totalVotes: 328505,
    winner: "R"
  },
  {
    state: "Florida",
    district: "22",
    demCandidate: "Lois Frankel",
    demVotes: 150010,
    repCandidate: "Dan Franzese",
    repVotes: 122194,
    totalVotes: 272204,
    winner: "D"
  },
  {
    state: "Florida",
    district: "23",
    demCandidate: "Jared Moskowitz",
    demVotes: 143951,
    repCandidate: "Joe Budd",
    repVotes: 130681,
    totalVotes: 274632,
    winner: "D"
  },
  {
    state: "Florida",
    district: "24",
    demCandidate: "Frederica S Wilson",
    demVotes: 133442,
    repCandidate: "Jesus G Navarro",
    repVotes: 52449,
    totalVotes: 185891,
    winner: "D"
  },
  {
    state: "Florida",
    district: "25",
    demCandidate: "Debbie Wasserman Schultz",
    demVotes: 129113,
    repCandidate: "Carla Spalding",
    repVotes: 105239,
    totalVotes: 234352,
    winner: "D"
  },
  {
    state: "Florida",
    district: "26",
    demCandidate: "Christine Alexandria Olivo",
    demVotes: 58868,
    repCandidate: "Mario Diaz-Balart",
    repVotes: 143240,
    totalVotes: 202108,
    winner: "R"
  },
  {
    state: "Florida",
    district: "27",
    demCandidate: "Annette Taddeo",
    demVotes: 101404,
    repCandidate: "Maria Elvira Salazar",
    repVotes: 136038,
    totalVotes: 237442,
    winner: "R"
  },
  {
    state: "Florida",
    district: "28",
    demCandidate: "Robert Asencio",
    demVotes: 76665,
    repCandidate: "Carlos A Gimenez",
    repVotes: 134457,
    totalVotes: 211122,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "1",
    demCandidate: "Wade Herring",
    demVotes: 107837,
    repCandidate: "Earl L  Carter",
    repVotes: 156128,
    totalVotes: 263965,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "2",
    demCandidate: "Sanford D Bishop, Jr",
    demVotes: 132675,
    repCandidate: "Chris West",
    repVotes: 108665,
    totalVotes: 241340,
    winner: "D"
  },
  {
    state: "Georgia",
    district: "3",
    demCandidate: "Val Almonord",
    demVotes: 97057,
    repCandidate: "A Drew Ferguson IV",
    repVotes: 213524,
    totalVotes: 310581,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "4",
    demCandidate: "Henry C  Johnson, Jr",
    demVotes: 216332,
    repCandidate: "Jonathan Chavez",
    repVotes: 59302,
    totalVotes: 275634,
    winner: "D"
  },
  {
    state: "Georgia",
    district: "5",
    demCandidate: "Nikema Williams",
    demVotes: 243687,
    repCandidate: "Christian Zimm",
    repVotes: 51769,
    totalVotes: 295456,
    winner: "D"
  },
  {
    state: "Georgia",
    district: "6",
    demCandidate: "Bob Christian",
    demVotes: 125612,
    repCandidate: "Rich McCormick",
    repVotes: 206886,
    totalVotes: 332498,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "7",
    demCandidate: "Lucy McBath",
    demVotes: 143063,
    repCandidate: "Mark Gonsalves",
    repVotes: 91962,
    totalVotes: 235025,
    winner: "D"
  },
  {
    state: "Georgia",
    district: "8",
    demCandidate: "Darrius Butler",
    demVotes: 81886,
    repCandidate: "Austin Scott",
    repVotes: 178700,
    totalVotes: 260586,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "9",
    demCandidate: "Michael  Ford",
    demVotes: 81318,
    repCandidate: "Andrew S Clyde",
    repVotes: 212820,
    totalVotes: 294138,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "10",
    demCandidate: "Tabitha Johnson-Green",
    demVotes: 109107,
    repCandidate: "Mike Collins",
    repVotes: 198523,
    totalVotes: 307630,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "11",
    demCandidate: "Antonio Daza",
    demVotes: 113571,
    repCandidate: "Barry Loudermilk",
    repVotes: 190086,
    totalVotes: 303657,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "12",
    demCandidate: "Elizabeth  Johnson",
    demVotes: 107148,
    repCandidate: "Rick W Allen",
    repVotes: 158047,
    totalVotes: 265195,
    winner: "R"
  },
  {
    state: "Georgia",
    district: "13",
    demCandidate: "David Scott",
    demVotes: 216388,
    repCandidate: "Caesar Gonzales",
    repVotes: 48228,
    totalVotes: 264616,
    winner: "D"
  },
  {
    state: "Georgia",
    district: "14",
    demCandidate: "Marcus Flowers",
    demVotes: 88189,
    repCandidate: "Marjorie Taylor Greene",
    repVotes: 170162,
    totalVotes: 258351,
    winner: "R"
  },
  {
    state: "Hawaii",
    district: "1",
    demCandidate: "Ed Case",
    demVotes: 143546,
    repCandidate: "Conrad Kress",
    repVotes: 51217,
    totalVotes: 194763,
    winner: "D"
  },
  {
    state: "Hawaii",
    district: "2",
    demCandidate: "Jill N Tokuda",
    demVotes: 128407,
    repCandidate: "Joe Akana",
    repVotes: 72874,
    totalVotes: 201281,
    winner: "D"
  },
  {
    state: "Iowa",
    district: "1",
    demCandidate: "Christina Bohannan",
    demVotes: 142173,
    repCandidate: "Mariannette Miller-Meeks",
    repVotes: 162947,
    totalVotes: 305120,
    winner: "R"
  },
  {
    state: "Iowa",
    district: "2",
    demCandidate: "Liz Mathis",
    demVotes: 145940,
    repCandidate: "Ashley Hinson",
    repVotes: 172181,
    totalVotes: 318121,
    winner: "R"
  },
  {
    state: "Iowa",
    district: "3",
    demCandidate: "Cynthia Axne",
    demVotes: 154117,
    repCandidate: "Zach Nunn",
    repVotes: 156262,
    totalVotes: 310379,
    winner: "R"
  },
  {
    state: "Iowa",
    district: "4",
    demCandidate: "Ryan Melton",
    demVotes: 84230,
    repCandidate: "Randy Feenstra",
    repVotes: 186467,
    totalVotes: 270697,
    winner: "R"
  },
  {
    state: "Idaho",
    district: "1",
    demCandidate: "Kaylee Peterson",
    demVotes: 82261,
    repCandidate: "Russ Fulcher",
    repVotes: 222901,
    totalVotes: 305162,
    winner: "R"
  },
  {
    state: "Idaho",
    district: "2",
    demCandidate: "Wendy Norman",
    demVotes: 98736,
    repCandidate: "Michael K Simpson",
    repVotes: 172450,
    totalVotes: 271186,
    winner: "R"
  },
  {
    state: "Illinois",
    district: "1",
    demCandidate: "Jonathan L Jackson",
    demVotes: 159142,
    repCandidate: "Eric Carlson",
    repVotes: 78258,
    totalVotes: 237400,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "2",
    demCandidate: "Robin L Kelly",
    demVotes: 140414,
    repCandidate: "Thomas Lynch",
    repVotes: 68761,
    totalVotes: 209175,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "3",
    demCandidate: "Delia Ramirez",
    demVotes: 121764,
    repCandidate: "Justin Burau",
    repVotes: 55995,
    totalVotes: 177759,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "4",
    demCandidate: "JesãS G  GarcãA",
    demVotes: 91036,
    repCandidate: "James Falakos",
    repVotes: 37352,
    totalVotes: 128388,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "5",
    demCandidate: "Mike Quigley",
    demVotes: 190999,
    repCandidate: "Tommy Hanson",
    repVotes: 79112,
    totalVotes: 270111,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "6",
    demCandidate: "Sean Casten",
    demVotes: 150496,
    repCandidate: "Keith Pekau",
    repVotes: 126351,
    totalVotes: 276847,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "7",
    demCandidate: "Danny K Davis",
    demVotes: 167650,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 167650,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "8",
    demCandidate: "Raja Krishnamoorthi",
    demVotes: 117880,
    repCandidate: "Chris Dargis",
    repVotes: 89335,
    totalVotes: 207215,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "9",
    demCandidate: "Janice D Schakowsky",
    demVotes: 179615,
    repCandidate: "Maxwell  Rice",
    repVotes: 70915,
    totalVotes: 250530,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "10",
    demCandidate: "Bradley Scott Schneider",
    demVotes: 152566,
    repCandidate: "Joseph Severino",
    repVotes: 89599,
    totalVotes: 242165,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "11",
    demCandidate: "Bill Foster",
    demVotes: 149172,
    repCandidate: "Catalina Lauf",
    repVotes: 115069,
    totalVotes: 264241,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "12",
    demCandidate: "Homer  Markel",
    demVotes: 72791,
    repCandidate: "Mike Bost",
    repVotes: 218379,
    totalVotes: 291170,
    winner: "R"
  },
  {
    state: "Illinois",
    district: "13",
    demCandidate: "Nikki Budzinski",
    demVotes: 141788,
    repCandidate: "Regan Deering",
    repVotes: 108646,
    totalVotes: 250434,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "14",
    demCandidate: "Lauren Underwood",
    demVotes: 128141,
    repCandidate: "Scott R Gryder",
    repVotes: 108451,
    totalVotes: 236592,
    winner: "D"
  },
  {
    state: "Illinois",
    district: "15",
    demCandidate: "Paul J Lange",
    demVotes: 86396,
    repCandidate: "Mary E Miller",
    repVotes: 213007,
    totalVotes: 299403,
    winner: "R"
  },
  {
    state: "Illinois",
    district: "16",
    demCandidate: "Elizabeth  Haderlein",
    demVotes: 100325,
    repCandidate: "Darin Lahood",
    repVotes: 197621,
    totalVotes: 297946,
    winner: "R"
  },
  {
    state: "Illinois",
    district: "17",
    demCandidate: "Eric Sorensen",
    demVotes: 121186,
    repCandidate: "Esther Joy King",
    repVotes: 111931,
    totalVotes: 233117,
    winner: "D"
  },
  {
    state: "Indiana",
    district: "1",
    demCandidate: "Frank J Mrvan",
    demVotes: 112656,
    repCandidate: "Jennifer-Ruth Green",
    repVotes: 100542,
    totalVotes: 213198,
    winner: "D"
  },
  {
    state: "Indiana",
    district: "2",
    demCandidate: "Paul D Steury",
    demVotes: 62891,
    repCandidate: "Rudolph  Yakym III",
    repVotes: 125313,
    totalVotes: 188204,
    winner: "R"
  },
  {
    state: "Indiana",
    district: "3",
    demCandidate: "Gary L Snyder",
    demVotes: 60577,
    repCandidate: "Jim Banks",
    repVotes: 131579,
    totalVotes: 192156,
    winner: "R"
  },
  {
    state: "Indiana",
    district: "4",
    demCandidate: "Roger D Day",
    demVotes: 62834,
    repCandidate: "James R Baird",
    repVotes: 134864,
    totalVotes: 197698,
    winner: "R"
  },
  {
    state: "Indiana",
    district: "5",
    demCandidate: "Jeannine Lee Lake",
    demVotes: 93434,
    repCandidate: "Victoria Spartz",
    repVotes: 146575,
    totalVotes: 240009,
    winner: "R"
  },
  {
    state: "Indiana",
    district: "6",
    demCandidate: "Cynthia  Wirth",
    demVotes: 62838,
    repCandidate: "Greg Pence",
    repVotes: 130686,
    totalVotes: 193524,
    winner: "R"
  },
  {
    state: "Indiana",
    district: "7",
    demCandidate: "Andrã Carson",
    demVotes: 117309,
    repCandidate: "Angela Grabovsky",
    repVotes: 53631,
    totalVotes: 170940,
    winner: "D"
  },
  {
    state: "Indiana",
    district: "8",
    demCandidate: "Ray McCormick",
    demVotes: 68109,
    repCandidate: "Larry Bucshon",
    repVotes: 141995,
    totalVotes: 210104,
    winner: "R"
  },
  {
    state: "Indiana",
    district: "9",
    demCandidate: "Matthew Fyfe",
    demVotes: 75700,
    repCandidate: "Erin Houchin",
    repVotes: 143166,
    totalVotes: 218866,
    winner: "R"
  },
  {
    state: "Kansas",
    district: "1",
    demCandidate: "James  Beard",
    demVotes: 77092,
    repCandidate: "Tracey Mann",
    repVotes: 161333,
    totalVotes: 238425,
    winner: "R"
  },
  {
    state: "Kansas",
    district: "2",
    demCandidate: "Patrick Schmidt",
    demVotes: 98852,
    repCandidate: "Jake Laturner",
    repVotes: 134506,
    totalVotes: 233358,
    winner: "R"
  },
  {
    state: "Kansas",
    district: "3",
    demCandidate: "Sharice Davids",
    demVotes: 165527,
    repCandidate: "Amanda L Adkins",
    repVotes: 128839,
    totalVotes: 294366,
    winner: "D"
  },
  {
    state: "Kansas",
    district: "4",
    demCandidate: "Bob Hernandez",
    demVotes: 83851,
    repCandidate: "Ron Estes",
    repVotes: 144889,
    totalVotes: 228740,
    winner: "R"
  },
  {
    state: "Kentucky",
    district: "1",
    demCandidate: "Jimmy C Ausbrooks",
    demVotes: 61701,
    repCandidate: "James Comer",
    repVotes: 184157,
    totalVotes: 245858,
    winner: "R"
  },
  {
    state: "Kentucky",
    district: "2",
    demCandidate: "Hank Linderman",
    demVotes: 66769,
    repCandidate: "Brett Guthrie",
    repVotes: 170487,
    totalVotes: 237256,
    winner: "R"
  },
  {
    state: "Kentucky",
    district: "3",
    demCandidate: "Morgan Mcgarvey",
    demVotes: 160920,
    repCandidate: "Stuart N Ray",
    repVotes: 98637,
    totalVotes: 259557,
    winner: "D"
  },
  {
    state: "Kentucky",
    district: "4",
    demCandidate: "Matthew Lehman",
    demVotes: 79977,
    repCandidate: "Thomas Massie",
    repVotes: 167541,
    totalVotes: 247518,
    winner: "R"
  },
  {
    state: "Kentucky",
    district: "5",
    demCandidate: "Conor Halbleib",
    demVotes: 38549,
    repCandidate: "Harold Rogers",
    repVotes: 177712,
    totalVotes: 216261,
    winner: "R"
  },
  {
    state: "Kentucky",
    district: "6",
    demCandidate: "Geoffrey M  Young",
    demVotes: 83005,
    repCandidate: "Andy Barr",
    repVotes: 154762,
    totalVotes: 237767,
    winner: "R"
  },
  {
    state: "Louisiana",
    district: "1",
    demCandidate: "Katie Darling",
    demVotes: 61467,
    repCandidate: "Steve Scalise",
    repVotes: 177670,
    totalVotes: 239137,
    winner: "R"
  },
  {
    state: "Louisiana",
    district: "2",
    demCandidate: "Troy A Carter",
    demVotes: 158120,
    repCandidate: " Lux",
    repVotes: 46927,
    totalVotes: 205047,
    winner: "D"
  },
  {
    state: "Louisiana",
    district: "3",
    demCandidate: "Lessie Olivia Leblanc",
    demVotes: 23641,
    repCandidate: "Clay Higgins",
    repVotes: 144423,
    totalVotes: 168064,
    winner: "R"
  },
  {
    state: "Louisiana",
    district: "4",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Mike Johnson",
    repVotes: 1,
    totalVotes: 1,
    winner: "R"
  },
  {
    state: "Louisiana",
    district: "5",
    demCandidate: "Oscar  Dantzler",
    demVotes: 35149,
    repCandidate: "Julia Letlow",
    repVotes: 151080,
    totalVotes: 186229,
    winner: "R"
  },
  {
    state: "Louisiana",
    district: "6",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Garret Graves",
    repVotes: 189684,
    totalVotes: 189684,
    winner: "R"
  },
  {
    state: "Massachusetts",
    district: "1",
    demCandidate: "Richard E Neal",
    demVotes: 157635,
    repCandidate: "Dean James Martilli",
    repVotes: 98386,
    totalVotes: 256021,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "2",
    demCandidate: "James P McGovern",
    demVotes: 180639,
    repCandidate: "Jeffrey A Sossa-Paquette",
    repVotes: 91956,
    totalVotes: 272595,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "3",
    demCandidate: "Lori Trahan",
    demVotes: 154496,
    repCandidate: "Dean A Tran",
    repVotes: 88585,
    totalVotes: 243081,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "4",
    demCandidate: "Jake Auchincloss",
    demVotes: 201882,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 201882,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "5",
    demCandidate: "Katherine M Clark",
    demVotes: 203994,
    repCandidate: "Caroline Colarusso",
    repVotes: 71491,
    totalVotes: 275485,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "6",
    demCandidate: "Seth Moulton",
    demVotes: 198119,
    repCandidate: "Bob May",
    repVotes: 110770,
    totalVotes: 308889,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "7",
    demCandidate: "Ayanna Pressley",
    demVotes: 151825,
    repCandidate: "Donnie Dionicio Palmer, Jr",
    repVotes: 27129,
    totalVotes: 178954,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "8",
    demCandidate: "Stephen F Lynch",
    demVotes: 189987,
    repCandidate: "Robert G Burke",
    repVotes: 82126,
    totalVotes: 272113,
    winner: "D"
  },
  {
    state: "Massachusetts",
    district: "9",
    demCandidate: "William R Keating",
    demVotes: 197823,
    repCandidate: "Jesse G Brown",
    repVotes: 136347,
    totalVotes: 334170,
    winner: "D"
  },
  {
    state: "Maryland",
    district: "1",
    demCandidate: "Heather R Mizeur",
    demVotes: 126511,
    repCandidate: "Andy Harris",
    repVotes: 159673,
    totalVotes: 286184,
    winner: "R"
  },
  {
    state: "Maryland",
    district: "2",
    demCandidate: "C A Dutch Ruppersberger",
    demVotes: 158998,
    repCandidate: "Nicolee Ambrose",
    repVotes: 109075,
    totalVotes: 268073,
    winner: "D"
  },
  {
    state: "Maryland",
    district: "3",
    demCandidate: "John P Sarbanes",
    demVotes: 175514,
    repCandidate: "Yuripzy Morgan",
    repVotes: 115801,
    totalVotes: 291315,
    winner: "D"
  },
  {
    state: "Maryland",
    district: "4",
    demCandidate: "Glenn F IVey",
    demVotes: 144168,
    repCandidate: "Jeff Warner",
    repVotes: 15441,
    totalVotes: 159609,
    winner: "D"
  },
  {
    state: "Maryland",
    district: "5",
    demCandidate: "Steny H Hoyer",
    demVotes: 182478,
    repCandidate: "Chris Palombi",
    repVotes: 94000,
    totalVotes: 276478,
    winner: "D"
  },
  {
    state: "Maryland",
    district: "6",
    demCandidate: "David J Trone",
    demVotes: 140295,
    repCandidate: "Neil C Parrott",
    repVotes: 115771,
    totalVotes: 256066,
    winner: "D"
  },
  {
    state: "Maryland",
    district: "7",
    demCandidate: "Kweisi Mfume",
    demVotes: 151640,
    repCandidate: "Scott M Collier",
    repVotes: 32737,
    totalVotes: 184377,
    winner: "D"
  },
  {
    state: "Maryland",
    district: "8",
    demCandidate: "Jamie Raskin",
    demVotes: 211842,
    repCandidate: "Gregory Thomas Coll",
    repVotes: 47965,
    totalVotes: 259807,
    winner: "D"
  },
  {
    state: "Maine",
    district: "1",
    demCandidate: "Chellie Pingree",
    demVotes: 219753,
    repCandidate: "Edwin Thelander",
    repVotes: 129263,
    totalVotes: 349016,
    winner: "D"
  },
  {
    state: "Maine",
    district: "2",
    demCandidate: "Jared F Golden",
    demVotes: 1165136,
    repCandidate: "Bruce Poliquin",
    repVotes: 1146142,
    totalVotes: 2311278,
    winner: "D"
  },
  {
    state: "Michigan",
    district: "1",
    demCandidate: "Bob Lorinser",
    demVotes: 145403,
    repCandidate: "Jack Bergman",
    repVotes: 233094,
    totalVotes: 378497,
    winner: "R"
  },
  {
    state: "Michigan",
    district: "2",
    demCandidate: "Jerry Hilliard",
    demVotes: 116452,
    repCandidate: "John R Moolenaar",
    repVotes: 216222,
    totalVotes: 332674,
    winner: "R"
  },
  {
    state: "Michigan",
    district: "3",
    demCandidate: "Hillary Scholten",
    demVotes: 185989,
    repCandidate: "John Gibbs",
    repVotes: 142229,
    totalVotes: 328218,
    winner: "D"
  },
  {
    state: "Michigan",
    district: "4",
    demCandidate: "Joseph Alfonso",
    demVotes: 143690,
    repCandidate: "Bill Huizenga",
    repVotes: 183936,
    totalVotes: 327626,
    winner: "R"
  },
  {
    state: "Michigan",
    district: "5",
    demCandidate: "Bart Goldberg",
    demVotes: 110946,
    repCandidate: "Tim Walberg",
    repVotes: 198020,
    totalVotes: 308966,
    winner: "R"
  },
  {
    state: "Michigan",
    district: "6",
    demCandidate: "Debbie Dingell",
    demVotes: 241759,
    repCandidate: "Whittney Williams",
    repVotes: 125167,
    totalVotes: 366926,
    winner: "D"
  },
  {
    state: "Michigan",
    district: "7",
    demCandidate: "Elissa Slotkin",
    demVotes: 192809,
    repCandidate: "Tom Barrett",
    repVotes: 172624,
    totalVotes: 365433,
    winner: "D"
  },
  {
    state: "Michigan",
    district: "8",
    demCandidate: "Daniel T Kildee",
    demVotes: 178322,
    repCandidate: "Paul Junge",
    repVotes: 143850,
    totalVotes: 322172,
    winner: "D"
  },
  {
    state: "Michigan",
    district: "9",
    demCandidate: "Brian Jaye",
    demVotes: 123702,
    repCandidate: "Lisa McClain",
    repVotes: 238300,
    totalVotes: 362002,
    winner: "R"
  },
  {
    state: "Michigan",
    district: "10",
    demCandidate: "Carl J Marlinga",
    demVotes: 157602,
    repCandidate: "John James",
    repVotes: 159202,
    totalVotes: 316804,
    winner: "R"
  },
  {
    state: "Michigan",
    district: "11",
    demCandidate: "Haley M Stevens",
    demVotes: 224537,
    repCandidate: "Mark Ambrose",
    repVotes: 141642,
    totalVotes: 366179,
    winner: "D"
  },
  {
    state: "Michigan",
    district: "12",
    demCandidate: "Rashida Tlaib",
    demVotes: 196643,
    repCandidate: "Steven Elliott",
    repVotes: 72888,
    totalVotes: 269531,
    winner: "D"
  },
  {
    state: "Michigan",
    district: "13",
    demCandidate: "Shri Thanedar",
    demVotes: 166650,
    repCandidate: "Martell D Bivings",
    repVotes: 56187,
    totalVotes: 222837,
    winner: "D"
  },
  {
    state: "Minnesota",
    district: "1",
    demCandidate: "Jeff Ettinger",
    demVotes: 125457,
    repCandidate: "Brad Finstad",
    repVotes: 159621,
    totalVotes: 285078,
    winner: "R"
  },
  {
    state: "Minnesota",
    district: "2",
    demCandidate: "Angie Craig",
    demVotes: 165583,
    repCandidate: "Tyler Kistner",
    repVotes: 148576,
    totalVotes: 314159,
    winner: "D"
  },
  {
    state: "Minnesota",
    district: "3",
    demCandidate: "Dean Phillips",
    demVotes: 198883,
    repCandidate: "Tom Weiler",
    repVotes: 134797,
    totalVotes: 333680,
    winner: "D"
  },
  {
    state: "Minnesota",
    district: "4",
    demCandidate: "Betty Mccollum",
    demVotes: 200055,
    repCandidate: "May Lor Xiong",
    repVotes: 95493,
    totalVotes: 295548,
    winner: "D"
  },
  {
    state: "Minnesota",
    district: "5",
    demCandidate: "Ilhan Omar",
    demVotes: 214224,
    repCandidate: "Cicely Davis",
    repVotes: 70702,
    totalVotes: 284926,
    winner: "D"
  },
  {
    state: "Minnesota",
    district: "6",
    demCandidate: "Jeanne Hendricks",
    demVotes: 120852,
    repCandidate: "Tom Emmer",
    repVotes: 198145,
    totalVotes: 318997,
    winner: "R"
  },
  {
    state: "Minnesota",
    district: "7",
    demCandidate: "Jill Abahsain",
    demVotes: 84455,
    repCandidate: "Michelle Fischbach",
    repVotes: 204766,
    totalVotes: 289221,
    winner: "R"
  },
  {
    state: "Minnesota",
    district: "8",
    demCandidate: "Jen Schultz",
    demVotes: 141009,
    repCandidate: "Pete Stauber",
    repVotes: 188755,
    totalVotes: 329764,
    winner: "R"
  },
  {
    state: "Missouri",
    district: "1",
    demCandidate: "Cori Bush",
    demVotes: 160999,
    repCandidate: "Andrew Jones",
    repVotes: 53767,
    totalVotes: 214766,
    winner: "D"
  },
  {
    state: "Missouri",
    district: "2",
    demCandidate: "Trish Gunby",
    demVotes: 135895,
    repCandidate: "Ann Wagner",
    repVotes: 173277,
    totalVotes: 309172,
    winner: "R"
  },
  {
    state: "Missouri",
    district: "3",
    demCandidate: "Bethany Mann",
    demVotes: 96851,
    repCandidate: "Blaine Luetkemeyer",
    repVotes: 180746,
    totalVotes: 277597,
    winner: "R"
  },
  {
    state: "Missouri",
    district: "4",
    demCandidate: "Jack Truman",
    demVotes: 67069,
    repCandidate: "Mark Alford",
    repVotes: 181890,
    totalVotes: 248959,
    winner: "R"
  },
  {
    state: "Missouri",
    district: "5",
    demCandidate: "Emanuel Cleaver",
    demVotes: 140688,
    repCandidate: "Jacob Turk",
    repVotes: 84008,
    totalVotes: 224696,
    winner: "D"
  },
  {
    state: "Missouri",
    district: "6",
    demCandidate: "Henry Martin",
    demVotes: 72253,
    repCandidate: "Sam Graves",
    repVotes: 184865,
    totalVotes: 257118,
    winner: "R"
  },
  {
    state: "Missouri",
    district: "7",
    demCandidate: "Kristen Radaker-Sheafer",
    demVotes: 67485,
    repCandidate: "Eric Burlison",
    repVotes: 178592,
    totalVotes: 246077,
    winner: "R"
  },
  {
    state: "Missouri",
    district: "8",
    demCandidate: "Randi Mccallian",
    demVotes: 53738,
    repCandidate: "Jason Smith",
    repVotes: 186472,
    totalVotes: 240210,
    winner: "R"
  },
  {
    state: "Mississippi",
    district: "1",
    demCandidate: "Dianne Black",
    demVotes: 45238,
    repCandidate: "Trent Kelly",
    repVotes: 122151,
    totalVotes: 167389,
    winner: "R"
  },
  {
    state: "Mississippi",
    district: "2",
    demCandidate: "Bennie G Thompson",
    demVotes: 108285,
    repCandidate: "Brian Flowers",
    repVotes: 71884,
    totalVotes: 180169,
    winner: "D"
  },
  {
    state: "Mississippi",
    district: "3",
    demCandidate: "Shuwaski A Young",
    demVotes: 54803,
    repCandidate: "Michael Guest",
    repVotes: 132481,
    totalVotes: 187284,
    winner: "R"
  },
  {
    state: "Mississippi",
    district: "4",
    demCandidate: "Johnny L Dupree",
    demVotes: 42876,
    repCandidate: "Mike Ezell",
    repVotes: 127813,
    totalVotes: 170689,
    winner: "R"
  },
  {
    state: "Montana",
    district: "1",
    demCandidate: "Monica Tranel",
    demVotes: 115265,
    repCandidate: "Ryan K Zinke",
    repVotes: 123102,
    totalVotes: 238367,
    winner: "R"
  },
  {
    state: "Montana",
    district: "2",
    demCandidate: "Penny Ronning",
    demVotes: 43480,
    repCandidate: "Matthew M Rosendale, Sr",
    repVotes: 121979,
    totalVotes: 165459,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "1",
    demCandidate: "Don Davis",
    demVotes: 134996,
    repCandidate: "Sandy Smith",
    repVotes: 122780,
    totalVotes: 257776,
    winner: "D"
  },
  {
    state: "North Carolina",
    district: "2",
    demCandidate: "Deborah K Ross",
    demVotes: 190714,
    repCandidate: "Christine E Villaverde",
    repVotes: 104155,
    totalVotes: 294869,
    winner: "D"
  },
  {
    state: "North Carolina",
    district: "3",
    demCandidate: "Barbara D Gaskins",
    demVotes: 82378,
    repCandidate: "Gregory F Murphy",
    repVotes: 166520,
    totalVotes: 248898,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "4",
    demCandidate: "Valerie P Foushee",
    demVotes: 194983,
    repCandidate: "Courtney Geels",
    repVotes: 96442,
    totalVotes: 291425,
    winner: "D"
  },
  {
    state: "North Carolina",
    district: "5",
    demCandidate: "Kyle Parrish",
    demVotes: 102269,
    repCandidate: "Virginia Foxx",
    repVotes: 175279,
    totalVotes: 277548,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "6",
    demCandidate: "Kathy E Manning",
    demVotes: 139553,
    repCandidate: "Christian Castelli",
    repVotes: 116635,
    totalVotes: 256188,
    winner: "D"
  },
  {
    state: "North Carolina",
    district: "7",
    demCandidate: "Charles Graham",
    demVotes: 120222,
    repCandidate: "David Rouzer",
    repVotes: 164047,
    totalVotes: 284269,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "8",
    demCandidate: "Scott Huffman",
    demVotes: 79192,
    repCandidate: "Dan Bishop",
    repVotes: 183998,
    totalVotes: 263190,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "9",
    demCandidate: "Ben Clark",
    demVotes: 101202,
    repCandidate: "Richard Hudson",
    repVotes: 131453,
    totalVotes: 232655,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "10",
    demCandidate: "Pam Genant",
    demVotes: 73174,
    repCandidate: "Patrick T McHenry",
    repVotes: 194681,
    totalVotes: 267855,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "11",
    demCandidate: "Jasmine Beach-Ferrara",
    demVotes: 144165,
    repCandidate: "Chuck Edwards",
    repVotes: 174232,
    totalVotes: 318397,
    winner: "R"
  },
  {
    state: "North Carolina",
    district: "12",
    demCandidate: "Alma S Adams",
    demVotes: 140494,
    repCandidate: "Tyler Lee",
    repVotes: 83414,
    totalVotes: 223908,
    winner: "D"
  },
  {
    state: "North Carolina",
    district: "13",
    demCandidate: "Wiley Nickel",
    demVotes: 143090,
    repCandidate: "Bo Hines",
    repVotes: 134256,
    totalVotes: 277346,
    winner: "D"
  },
  {
    state: "North Carolina",
    district: "14",
    demCandidate: "Jeff Jackson",
    demVotes: 148738,
    repCandidate: "Pat Harrigan",
    repVotes: 109014,
    totalVotes: 257752,
    winner: "D"
  },
  {
    state: "North Dakota",
    district: "AL",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Kelly Armstrong",
    repVotes: 148399,
    totalVotes: 148399,
    winner: "R"
  },
  {
    state: "Nebraska",
    district: "1",
    demCandidate: "Patty Pansing Brooks",
    demVotes: 93929,
    repCandidate: "Mike Flood",
    repVotes: 129236,
    totalVotes: 223165,
    winner: "R"
  },
  {
    state: "Nebraska",
    district: "2",
    demCandidate: "Tony Vargas",
    demVotes: 106807,
    repCandidate: "Don Bacon",
    repVotes: 112663,
    totalVotes: 219470,
    winner: "R"
  },
  {
    state: "Nebraska",
    district: "3",
    demCandidate: "David J Else",
    demVotes: 34836,
    repCandidate: "Adrian Smith",
    repVotes: 172700,
    totalVotes: 207536,
    winner: "R"
  },
  {
    state: "New Hampshire",
    district: "1",
    demCandidate: "Chris Pappas",
    demVotes: 167391,
    repCandidate: "Karoline Leavitt",
    repVotes: 142229,
    totalVotes: 309620,
    winner: "D"
  },
  {
    state: "New Hampshire",
    district: "2",
    demCandidate: "Ann M Kuster",
    demVotes: 171636,
    repCandidate: "Robert Burns",
    repVotes: 135579,
    totalVotes: 307215,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "1",
    demCandidate: "Donald Norcross",
    demVotes: 139559,
    repCandidate: "Claire Gustafson",
    repVotes: 78794,
    totalVotes: 218353,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "2",
    demCandidate: "Tim Alexander",
    demVotes: 94522,
    repCandidate: "Jefferson Van Drew",
    repVotes: 139217,
    totalVotes: 233739,
    winner: "R"
  },
  {
    state: "New Jersey",
    district: "3",
    demCandidate: "Andy Kim",
    demVotes: 150498,
    repCandidate: "Bob Healey",
    repVotes: 118415,
    totalVotes: 268913,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "4",
    demCandidate: "Matthew Jenkins",
    demVotes: 81233,
    repCandidate: "Christopher H Smith",
    repVotes: 173288,
    totalVotes: 254521,
    winner: "R"
  },
  {
    state: "New Jersey",
    district: "5",
    demCandidate: "Josh Gottheimer",
    demVotes: 145559,
    repCandidate: "Frank T Pallotta",
    repVotes: 117873,
    totalVotes: 263432,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "6",
    demCandidate: "Frank Pallone, Jr",
    demVotes: 106238,
    repCandidate: "Susan M Kiley",
    repVotes: 75839,
    totalVotes: 182077,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "7",
    demCandidate: "Tom Malinowski",
    demVotes: 150701,
    repCandidate: "Thomas H Kean, Jr",
    repVotes: 159392,
    totalVotes: 310093,
    winner: "R"
  },
  {
    state: "New Jersey",
    district: "8",
    demCandidate: "Robert J Menendez",
    demVotes: 78382,
    repCandidate: "Marcos Arroyo",
    repVotes: 24957,
    totalVotes: 103339,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "9",
    demCandidate: "Bill Pascrell, Jr",
    demVotes: 82457,
    repCandidate: "Billy Prempeh",
    repVotes: 65365,
    totalVotes: 147822,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "10",
    demCandidate: "Donald M Payne, Jr",
    demVotes: 100710,
    repCandidate: "David H Pinckney",
    repVotes: 25993,
    totalVotes: 126703,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "11",
    demCandidate: "Mikie Sherrill",
    demVotes: 161436,
    repCandidate: "Paul Degroot",
    repVotes: 109952,
    totalVotes: 271388,
    winner: "D"
  },
  {
    state: "New Jersey",
    district: "12",
    demCandidate: "Bonnie Watson Coleman",
    demVotes: 125127,
    repCandidate: "Darius Mayfield",
    repVotes: 71175,
    totalVotes: 196302,
    winner: "D"
  },
  {
    state: "New Mexico",
    district: "1",
    demCandidate: "Melanie A Stansbury",
    demVotes: 156462,
    repCandidate: "Michelle Garcia Holmes",
    repVotes: 124151,
    totalVotes: 280613,
    winner: "D"
  },
  {
    state: "New Mexico",
    district: "2",
    demCandidate: "Gabriel Vasquez",
    demVotes: 96986,
    repCandidate: "Yvette Herrell",
    repVotes: 95636,
    totalVotes: 192622,
    winner: "D"
  },
  {
    state: "New Mexico",
    district: "3",
    demCandidate: "Teresa Leger Fernandez",
    demVotes: 134217,
    repCandidate: "Alexis Martinez Johnson",
    repVotes: 96565,
    totalVotes: 230782,
    winner: "D"
  },
  {
    state: "Nevada",
    district: "1",
    demCandidate: "Dina Titus",
    demVotes: 115700,
    repCandidate: "Mark Robertson",
    repVotes: 103115,
    totalVotes: 218815,
    winner: "D"
  },
  {
    state: "Nevada",
    district: "2",
    demCandidate: "Elizabeth Mercedes Krause",
    demVotes: 117371,
    repCandidate: "Mark E Amodei",
    repVotes: 185467,
    totalVotes: 302838,
    winner: "R"
  },
  {
    state: "Nevada",
    district: "3",
    demCandidate: "Susie Lee",
    demVotes: 131086,
    repCandidate: "April Becker",
    repVotes: 121083,
    totalVotes: 252169,
    winner: "D"
  },
  {
    state: "Nevada",
    district: "4",
    demCandidate: "Steven Horsford",
    demVotes: 116617,
    repCandidate: "Sam Peters",
    repVotes: 105870,
    totalVotes: 222487,
    winner: "D"
  },
  {
    state: "New York",
    district: "1",
    demCandidate: "Bridget Fleming",
    demVotes: 141907,
    repCandidate: "Nicholas J Lalota",
    repVotes: 177040,
    totalVotes: 318947,
    winner: "R"
  },
  {
    state: "New York",
    district: "2",
    demCandidate: "Jackie Gordon",
    demVotes: 97774,
    repCandidate: "Andrew R Garbarino",
    repVotes: 151178,
    totalVotes: 248952,
    winner: "R"
  },
  {
    state: "New York",
    district: "3",
    demCandidate: "Robert P Zimmerman",
    demVotes: 125404,
    repCandidate: "George A D Santos",
    repVotes: 145824,
    totalVotes: 271228,
    winner: "R"
  },
  {
    state: "New York",
    district: "4",
    demCandidate: "Laura A Gillen",
    demVotes: 130871,
    repCandidate: "Anthony P D\"Esposito",
    repVotes: 140622,
    totalVotes: 271493,
    winner: "R"
  },
  {
    state: "New York",
    district: "5",
    demCandidate: "Gregory W Meeks",
    demVotes: 104396,
    repCandidate: "Paul King",
    repVotes: 34407,
    totalVotes: 138803,
    winner: "D"
  },
  {
    state: "New York",
    district: "6",
    demCandidate: "Grace Meng",
    demVotes: 85049,
    repCandidate: "Thomas J Zmich",
    repVotes: 47935,
    totalVotes: 132984,
    winner: "D"
  },
  {
    state: "New York",
    district: "7",
    demCandidate: "Nydia M VelãZquez",
    demVotes: 119473,
    repCandidate: "Juan Pagan",
    repVotes: 28597,
    totalVotes: 148070,
    winner: "D"
  },
  {
    state: "New York",
    district: "8",
    demCandidate: "Hakeem S Jeffries",
    demVotes: 99079,
    repCandidate: "Yuri Dashevsky",
    repVotes: 39060,
    totalVotes: 138139,
    winner: "D"
  },
  {
    state: "New York",
    district: "9",
    demCandidate: "Yvette D Clarke",
    demVotes: 116970,
    repCandidate: "Menachem M Raitport",
    repVotes: 26521,
    totalVotes: 143491,
    winner: "D"
  },
  {
    state: "New York",
    district: "10",
    demCandidate: "Daniel Goldman",
    demVotes: 160582,
    repCandidate: "Benine A Hamdan",
    repVotes: 29058,
    totalVotes: 189640,
    winner: "D"
  },
  {
    state: "New York",
    district: "11",
    demCandidate: "Max N Rose",
    demVotes: 71801,
    repCandidate: "Nicole Malliotakis",
    repVotes: 115992,
    totalVotes: 187793,
    winner: "R"
  },
  {
    state: "New York",
    district: "12",
    demCandidate: "Jerrold Nadler",
    demVotes: 200890,
    repCandidate: "Michael K Zumbluskas",
    repVotes: 44173,
    totalVotes: 245063,
    winner: "D"
  },
  {
    state: "New York",
    district: "13",
    demCandidate: "Adriano Espaillat",
    demVotes: 116589,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 116589,
    winner: "D"
  },
  {
    state: "New York",
    district: "14",
    demCandidate: "Alexandria Ocasio-Cortez",
    demVotes: 82453,
    repCandidate: "Tina Forte",
    repVotes: 31935,
    totalVotes: 114388,
    winner: "D"
  },
  {
    state: "New York",
    district: "15",
    demCandidate: "Ritchie Torres",
    demVotes: 76406,
    repCandidate: "Stylo A Sapaskis",
    repVotes: 15882,
    totalVotes: 92288,
    winner: "D"
  },
  {
    state: "New York",
    district: "16",
    demCandidate: "Jamaal Bowman",
    demVotes: 133567,
    repCandidate: "Miriam L Flisser",
    repVotes: 74156,
    totalVotes: 207723,
    winner: "D"
  },
  {
    state: "New York",
    district: "17",
    demCandidate: "Sean Patrick Maloney",
    demVotes: 141730,
    repCandidate: "Michael V Lawler",
    repVotes: 143550,
    totalVotes: 285280,
    winner: "R"
  },
  {
    state: "New York",
    district: "18",
    demCandidate: "Patrick Ryan",
    demVotes: 135245,
    repCandidate: "Colin J Schmitt",
    repVotes: 131653,
    totalVotes: 266898,
    winner: "D"
  },
  {
    state: "New York",
    district: "19",
    demCandidate: "Josh Riley",
    demVotes: 141509,
    repCandidate: "Marcus Molinaro",
    repVotes: 146004,
    totalVotes: 287513,
    winner: "R"
  },
  {
    state: "New York",
    district: "20",
    demCandidate: "Paul Tonko",
    demVotes: 160420,
    repCandidate: "Elizabeth L Joy",
    repVotes: 130869,
    totalVotes: 291289,
    winner: "D"
  },
  {
    state: "New York",
    district: "21",
    demCandidate: "Matt Castelli",
    demVotes: 112645,
    repCandidate: "Elise M Stefanik",
    repVotes: 168579,
    totalVotes: 281224,
    winner: "R"
  },
  {
    state: "New York",
    district: "22",
    demCandidate: "Francis Conole",
    demVotes: 132913,
    repCandidate: "Brandon M Williams",
    repVotes: 135544,
    totalVotes: 268457,
    winner: "R"
  },
  {
    state: "New York",
    district: "23",
    demCandidate: "Max H Della Pia",
    demVotes: 104114,
    repCandidate: "Nick Langworthy",
    repVotes: 192694,
    totalVotes: 296808,
    winner: "R"
  },
  {
    state: "New York",
    district: "24",
    demCandidate: "Steven Holden",
    demVotes: 95028,
    repCandidate: "Claudia Tenney",
    repVotes: 182054,
    totalVotes: 277082,
    winner: "R"
  },
  {
    state: "New York",
    district: "25",
    demCandidate: "Joseph D Morelle",
    demVotes: 152022,
    repCandidate: "La\"Ron D Singletary",
    repVotes: 130190,
    totalVotes: 282212,
    winner: "D"
  },
  {
    state: "New York",
    district: "26",
    demCandidate: "Brian Higgins",
    demVotes: 156883,
    repCandidate: "Steven L Sams II",
    repVotes: 88339,
    totalVotes: 245222,
    winner: "D"
  },
  {
    state: "Ohio",
    district: "1",
    demCandidate: "Greg Landsman",
    demVotes: 156416,
    repCandidate: "Steve Chabot",
    repVotes: 140058,
    totalVotes: 296474,
    winner: "D"
  },
  {
    state: "Ohio",
    district: "2",
    demCandidate: "Samantha Meadows",
    demVotes: 65745,
    repCandidate: "Brad R Wenstrup",
    repVotes: 192117,
    totalVotes: 257862,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "3",
    demCandidate: "Joyce Beatty",
    demVotes: 182324,
    repCandidate: "Lee R Stahley",
    repVotes: 76455,
    totalVotes: 258779,
    winner: "D"
  },
  {
    state: "Ohio",
    district: "4",
    demCandidate: "Tamie Wilson",
    demVotes: 89383,
    repCandidate: "Jim Jordan",
    repVotes: 200773,
    totalVotes: 290156,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "5",
    demCandidate: "Craig Swartz",
    demVotes: 92634,
    repCandidate: "Robert E Latta",
    repVotes: 187303,
    totalVotes: 279937,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "6",
    demCandidate: "Louis G Lyras",
    demVotes: 90500,
    repCandidate: "Bill Johnson",
    repVotes: 189883,
    totalVotes: 280383,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "7",
    demCandidate: "Matthew Diemer",
    demVotes: 135485,
    repCandidate: "Max Miller",
    repVotes: 168002,
    totalVotes: 303487,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "8",
    demCandidate: "Vanessa Enoch",
    demVotes: 98629,
    repCandidate: "Warren Davidson",
    repVotes: 180287,
    totalVotes: 278916,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "9",
    demCandidate: "Marcy Kaptur",
    demVotes: 150655,
    repCandidate: "J R Majewski",
    repVotes: 115362,
    totalVotes: 266017,
    winner: "D"
  },
  {
    state: "Ohio",
    district: "10",
    demCandidate: "David Esrati",
    demVotes: 104634,
    repCandidate: "Michael R Turner",
    repVotes: 168327,
    totalVotes: 272961,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "11",
    demCandidate: "Shontel M Brown",
    demVotes: 167722,
    repCandidate: "Eric J Brewer",
    repVotes: 47988,
    totalVotes: 215710,
    winner: "D"
  },
  {
    state: "Ohio",
    district: "12",
    demCandidate: "Amy Rippel-Elton",
    demVotes: 84893,
    repCandidate: "Troy Balderson",
    repVotes: 191344,
    totalVotes: 276237,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "13",
    demCandidate: "Emilia Sykes",
    demVotes: 149816,
    repCandidate: "Madison Gesiotto Gilbert",
    repVotes: 134593,
    totalVotes: 284409,
    winner: "D"
  },
  {
    state: "Ohio",
    district: "14",
    demCandidate: "Matt Kilboy",
    demVotes: 113639,
    repCandidate: "David P Joyce",
    repVotes: 183389,
    totalVotes: 297028,
    winner: "R"
  },
  {
    state: "Ohio",
    district: "15",
    demCandidate: "Gary Josephson",
    demVotes: 108139,
    repCandidate: "Mike Carey",
    repVotes: 143112,
    totalVotes: 251251,
    winner: "R"
  },
  {
    state: "Oklahoma",
    district: "1",
    demCandidate: "Adam Martin",
    demVotes: 80974,
    repCandidate: "Kevin Hern",
    repVotes: 142800,
    totalVotes: 223774,
    winner: "R"
  },
  {
    state: "Oklahoma",
    district: "2",
    demCandidate: "Naomi Andrews",
    demVotes: 54194,
    repCandidate: "Josh Brecheen",
    repVotes: 167843,
    totalVotes: 222037,
    winner: "R"
  },
  {
    state: "Oklahoma",
    district: "3",
    demCandidate: "Jeremiah A Ross",
    demVotes: 50354,
    repCandidate: "Frank D Lucas",
    repVotes: 147418,
    totalVotes: 197772,
    winner: "R"
  },
  {
    state: "Oklahoma",
    district: "4",
    demCandidate: "Mary Brannon",
    demVotes: 74667,
    repCandidate: "Tom Cole",
    repVotes: 149879,
    totalVotes: 224546,
    winner: "R"
  },
  {
    state: "Oklahoma",
    district: "5",
    demCandidate: "Joshua Harris-Till",
    demVotes: 96799,
    repCandidate: "Stephanie I Bice",
    repVotes: 152699,
    totalVotes: 249498,
    winner: "R"
  },
  {
    state: "Oregon",
    district: "1",
    demCandidate: "Suzanne Bonamici",
    demVotes: 210682,
    repCandidate: "Christopher A Mann",
    repVotes: 99042,
    totalVotes: 309724,
    winner: "D"
  },
  {
    state: "Oregon",
    district: "2",
    demCandidate: "Joe Yetter",
    demVotes: 99882,
    repCandidate: "Cliff Bentz",
    repVotes: 208369,
    totalVotes: 308251,
    winner: "R"
  },
  {
    state: "Oregon",
    district: "3",
    demCandidate: "Earl Blumenauer",
    demVotes: 212119,
    repCandidate: "Joanna Harbour",
    repVotes: 79766,
    totalVotes: 291885,
    winner: "D"
  },
  {
    state: "Oregon",
    district: "4",
    demCandidate: "Val Hoyle",
    demVotes: 171372,
    repCandidate: "Alek Skarlatos",
    repVotes: 146055,
    totalVotes: 317427,
    winner: "D"
  },
  {
    state: "Oregon",
    district: "5",
    demCandidate: "Jamie Mcleod-Skinner",
    demVotes: 171514,
    repCandidate: "Lori Chavez-Deremer",
    repVotes: 178813,
    totalVotes: 350327,
    winner: "R"
  },
  {
    state: "Oregon",
    district: "6",
    demCandidate: "Andrea Salinas",
    demVotes: 147156,
    repCandidate: "Mike Erickson",
    repVotes: 139946,
    totalVotes: 287102,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "1",
    demCandidate: "Ashley Ehasz",
    demVotes: 165809,
    repCandidate: "Brian K Fitzpatrick",
    repVotes: 201571,
    totalVotes: 367380,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "2",
    demCandidate: "Brendan F Boyle",
    demVotes: 141229,
    repCandidate: "Aaron Bashir",
    repVotes: 45454,
    totalVotes: 186683,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "3",
    demCandidate: "Dwight Evans",
    demVotes: 251115,
    repCandidate: "",
    repVotes: 0,
    totalVotes: 251115,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "4",
    demCandidate: "Madeleine Dean",
    demVotes: 224799,
    repCandidate: "Christian Nascimento",
    repVotes: 141986,
    totalVotes: 366785,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "5",
    demCandidate: "Mary Gay Scanlon",
    demVotes: 205128,
    repCandidate: "David Galluch",
    repVotes: 110058,
    totalVotes: 315186,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "6",
    demCandidate: "Chrissy Houlahan",
    demVotes: 190386,
    repCandidate: "Guy Ciarrocchi",
    repVotes: 136097,
    totalVotes: 326483,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "7",
    demCandidate: "Susan Wild",
    demVotes: 151364,
    repCandidate: "Lisa Scheller",
    repVotes: 145527,
    totalVotes: 296891,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "8",
    demCandidate: "Matt Cartwright",
    demVotes: 146956,
    repCandidate: "Jim Bognet",
    repVotes: 139930,
    totalVotes: 286886,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "9",
    demCandidate: "Amanda R Waldman",
    demVotes: 92622,
    repCandidate: "Daniel Meuser",
    repVotes: 209185,
    totalVotes: 301807,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "10",
    demCandidate: "Shamaine Daniels",
    demVotes: 145215,
    repCandidate: "Scott Perry",
    repVotes: 169331,
    totalVotes: 314546,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "11",
    demCandidate: "Bob Hollister",
    demVotes: 121835,
    repCandidate: "Lloyd Smucker",
    repVotes: 194991,
    totalVotes: 316826,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "12",
    demCandidate: "Summer Lee",
    demVotes: 184674,
    repCandidate: "Mike Doyle",
    repVotes: 143946,
    totalVotes: 328620,
    winner: "D"
  },
  {
    state: "Pennsylvania",
    district: "13",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "John Joyce",
    repVotes: 260345,
    totalVotes: 260345,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "14",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Guy Reschenthaler",
    repVotes: 230865,
    totalVotes: 230865,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "15",
    demCandidate: "Mike Molesevich",
    demVotes: 91729,
    repCandidate: "Glenn Thompson",
    repVotes: 213417,
    totalVotes: 305146,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "16",
    demCandidate: "Dan Pastore",
    demVotes: 130443,
    repCandidate: "Mike Kelly",
    repVotes: 190546,
    totalVotes: 320989,
    winner: "R"
  },
  {
    state: "Pennsylvania",
    district: "17",
    demCandidate: "Chris Deluzio",
    demVotes: 193615,
    repCandidate: "Jeremy Shaffer",
    repVotes: 169013,
    totalVotes: 362628,
    winner: "D"
  },
  {
    state: "Rhode Island",
    district: "1",
    demCandidate: "David N Cicilline",
    demVotes: 100318,
    repCandidate: "Allen R Waters",
    repVotes: 56055,
    totalVotes: 156373,
    winner: "D"
  },
  {
    state: "Rhode Island",
    district: "2",
    demCandidate: "Seth M Magaziner",
    demVotes: 101432,
    repCandidate: "Allan W Fung",
    repVotes: 93969,
    totalVotes: 195401,
    winner: "D"
  },
  {
    state: "South Carolina",
    district: "1",
    demCandidate: "Annie Andrews",
    demVotes: 115796,
    repCandidate: "Nancy Mace",
    repVotes: 153757,
    totalVotes: 269553,
    winner: "R"
  },
  {
    state: "South Carolina",
    district: "2",
    demCandidate: "Judd Larkins",
    demVotes: 98081,
    repCandidate: "Joe Wilson",
    repVotes: 147699,
    totalVotes: 245780,
    winner: "R"
  },
  {
    state: "South Carolina",
    district: "3",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Jeff Duncan",
    repVotes: 189971,
    totalVotes: 189971,
    winner: "R"
  },
  {
    state: "South Carolina",
    district: "4",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "William R Timmons IV",
    repVotes: 165607,
    totalVotes: 165607,
    winner: "R"
  },
  {
    state: "South Carolina",
    district: "5",
    demCandidate: "Evangeline Hundley",
    demVotes: 83299,
    repCandidate: "Ralph Norman",
    repVotes: 154725,
    totalVotes: 238024,
    winner: "R"
  },
  {
    state: "South Carolina",
    district: "6",
    demCandidate: "James E Clyburn",
    demVotes: 130923,
    repCandidate: "Duke Buckner",
    repVotes: 79879,
    totalVotes: 210802,
    winner: "D"
  },
  {
    state: "South Carolina",
    district: "7",
    demCandidate: "Daryl W Scott",
    demVotes: 89030,
    repCandidate: "Russell Fry",
    repVotes: 164440,
    totalVotes: 253470,
    winner: "R"
  },
  {
    state: "South Dakota",
    district: "AL",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Dusty Johnson",
    repVotes: 253821,
    totalVotes: 253821,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "1",
    demCandidate: "Cameron Parsons",
    demVotes: 37049,
    repCandidate: "Diana Harshbarger",
    repVotes: 147241,
    totalVotes: 184290,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "2",
    demCandidate: "Mark Harmon",
    demVotes: 66673,
    repCandidate: "Tim Burchett",
    repVotes: 141089,
    totalVotes: 207762,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "3",
    demCandidate: "Meg Gorman",
    demVotes: 60334,
    repCandidate: "Charles J  Fleischmann",
    repVotes: 136639,
    totalVotes: 196973,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "4",
    demCandidate: "Wayne Steele",
    demVotes: 44648,
    repCandidate: "Scott DesJarlais",
    repVotes: 122401,
    totalVotes: 167049,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "5",
    demCandidate: "Heidi Campbell",
    demVotes: 93648,
    repCandidate: "Andy Ogles",
    repVotes: 123558,
    totalVotes: 217206,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "6",
    demCandidate: "Randal Cooper",
    demVotes: 65675,
    repCandidate: "John W Rose",
    repVotes: 129388,
    totalVotes: 195063,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "7",
    demCandidate: "Odessa Kelly",
    demVotes: 68973,
    repCandidate: "Mark E Green",
    repVotes: 108421,
    totalVotes: 177394,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "8",
    demCandidate: "Lynnette P Williams",
    demVotes: 51102,
    repCandidate: "David Kustoff",
    repVotes: 155602,
    totalVotes: 206704,
    winner: "R"
  },
  {
    state: "Tennessee",
    district: "9",
    demCandidate: "Steve Cohen",
    demVotes: 93800,
    repCandidate: "Charlotte Bergmann",
    repVotes: 35123,
    totalVotes: 128923,
    winner: "D"
  },
  {
    state: "Texas",
    district: "1",
    demCandidate: "Jrmar  Jefferson",
    demVotes: 51438,
    repCandidate: "Nathaniel Moran",
    repVotes: 183224,
    totalVotes: 234662,
    winner: "R"
  },
  {
    state: "Texas",
    district: "2",
    demCandidate: "Robin Fulford",
    demVotes: 78496,
    repCandidate: "Dan Crenshaw",
    repVotes: 151791,
    totalVotes: 230287,
    winner: "R"
  },
  {
    state: "Texas",
    district: "3",
    demCandidate: "Sandeep Srivastava",
    demVotes: 100121,
    repCandidate: "Keith Self",
    repVotes: 164240,
    totalVotes: 264361,
    winner: "R"
  },
  {
    state: "Texas",
    district: "4",
    demCandidate: "Iro Omere",
    demVotes: 79179,
    repCandidate: "Pat Fallon",
    repVotes: 170781,
    totalVotes: 249960,
    winner: "R"
  },
  {
    state: "Texas",
    district: "5",
    demCandidate: "Tartisha Hill",
    demVotes: 71930,
    repCandidate: "Lance Gooden",
    repVotes: 135595,
    totalVotes: 207525,
    winner: "R"
  },
  {
    state: "Texas",
    district: "6",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Jake Ellzey",
    repVotes: 149321,
    totalVotes: 149321,
    winner: "R"
  },
  {
    state: "Texas",
    district: "7",
    demCandidate: "Lizzie Fletcher",
    demVotes: 115994,
    repCandidate: "Johnny Teague",
    repVotes: 65835,
    totalVotes: 181829,
    winner: "D"
  },
  {
    state: "Texas",
    district: "8",
    demCandidate: "Laura Jones",
    demVotes: 68715,
    repCandidate: "Morgan Luttrell",
    repVotes: 153127,
    totalVotes: 221842,
    winner: "R"
  },
  {
    state: "Texas",
    district: "9",
    demCandidate: "Al Green",
    demVotes: 125446,
    repCandidate: "Jimmy I Leon",
    repVotes: 38161,
    totalVotes: 163607,
    winner: "D"
  },
  {
    state: "Texas",
    district: "10",
    demCandidate: "Linda Nuno",
    demVotes: 86404,
    repCandidate: "Michael T McCaul",
    repVotes: 159469,
    totalVotes: 245873,
    winner: "R"
  },
  {
    state: "Texas",
    district: "11",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "August Pfluger",
    repVotes: 151066,
    totalVotes: 151066,
    winner: "R"
  },
  {
    state: "Texas",
    district: "12",
    demCandidate: "Trey J Hunt",
    demVotes: 85026,
    repCandidate: "Kay Granger",
    repVotes: 152953,
    totalVotes: 237979,
    winner: "R"
  },
  {
    state: "Texas",
    district: "13",
    demCandidate: "Kathleen Brown",
    demVotes: 52910,
    repCandidate: "Ronny Jackson",
    repVotes: 161767,
    totalVotes: 214677,
    winner: "R"
  },
  {
    state: "Texas",
    district: "14",
    demCandidate: "Mikal Williams",
    demVotes: 63606,
    repCandidate: "Randy K Weber, Sr",
    repVotes: 149543,
    totalVotes: 213149,
    winner: "R"
  },
  {
    state: "Texas",
    district: "15",
    demCandidate: "Michelle Vallejo",
    demVotes: 68097,
    repCandidate: "Monica De La Cruz",
    repVotes: 80978,
    totalVotes: 149075,
    winner: "R"
  },
  {
    state: "Texas",
    district: "16",
    demCandidate: "Veronica Escobar",
    demVotes: 95510,
    repCandidate: "Irene Armendariz Jackson",
    repVotes: 54986,
    totalVotes: 150496,
    winner: "D"
  },
  {
    state: "Texas",
    district: "17",
    demCandidate: "Mary Jo Woods",
    demVotes: 72801,
    repCandidate: "Pete Sessions",
    repVotes: 144408,
    totalVotes: 217209,
    winner: "R"
  },
  {
    state: "Texas",
    district: "18",
    demCandidate: "Sheila Jackson Lee",
    demVotes: 110511,
    repCandidate: "Carmen Maria Montiel",
    repVotes: 40941,
    totalVotes: 151452,
    winner: "D"
  },
  {
    state: "Texas",
    district: "19",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Jodey C Arrington",
    repVotes: 152321,
    totalVotes: 152321,
    winner: "R"
  },
  {
    state: "Texas",
    district: "20",
    demCandidate: "Joaquin Castro",
    demVotes: 115352,
    repCandidate: "Kyle Sinclair",
    repVotes: 53226,
    totalVotes: 168578,
    winner: "D"
  },
  {
    state: "Texas",
    district: "21",
    demCandidate: "Claudia Andreana Zapata",
    demVotes: 122655,
    repCandidate: "Chip Roy",
    repVotes: 207426,
    totalVotes: 330081,
    winner: "R"
  },
  {
    state: "Texas",
    district: "22",
    demCandidate: "Jamie Kaye Jordan",
    demVotes: 85653,
    repCandidate: "Troy E Nehls",
    repVotes: 150014,
    totalVotes: 235667,
    winner: "R"
  },
  {
    state: "Texas",
    district: "23",
    demCandidate: "John Lira",
    demVotes: 80947,
    repCandidate: "Tony Gonzales",
    repVotes: 116649,
    totalVotes: 197596,
    winner: "R"
  },
  {
    state: "Texas",
    district: "24",
    demCandidate: "Jan Mcdowell",
    demVotes: 119878,
    repCandidate: "Beth Van Duyne",
    repVotes: 177947,
    totalVotes: 297825,
    winner: "R"
  },
  {
    state: "Texas",
    district: "25",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Roger Williams",
    repVotes: 185270,
    totalVotes: 185270,
    winner: "R"
  },
  {
    state: "Texas",
    district: "26",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Michael C Burgess",
    repVotes: 183639,
    totalVotes: 183639,
    winner: "R"
  },
  {
    state: "Texas",
    district: "27",
    demCandidate: "Maclovio Perez, Jr",
    demVotes: 73611,
    repCandidate: "Michael Cloud",
    repVotes: 133416,
    totalVotes: 207027,
    winner: "R"
  },
  {
    state: "Texas",
    district: "28",
    demCandidate: "Henry Cuellar",
    demVotes: 93803,
    repCandidate: "Cassy Garcia",
    repVotes: 71778,
    totalVotes: 165581,
    winner: "D"
  },
  {
    state: "Texas",
    district: "29",
    demCandidate: "Sylvia R Garcia",
    demVotes: 71837,
    repCandidate: "Robert Schafranek",
    repVotes: 28765,
    totalVotes: 100602,
    winner: "D"
  },
  {
    state: "Texas",
    district: "30",
    demCandidate: "Jasmine Crockett",
    demVotes: 134876,
    repCandidate: "James Rodgers",
    repVotes: 39209,
    totalVotes: 174085,
    winner: "D"
  },
  {
    state: "Texas",
    district: "31",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "John R Carter",
    repVotes: 183185,
    totalVotes: 183185,
    winner: "R"
  },
  {
    state: "Texas",
    district: "32",
    demCandidate: "Colin Z Allred",
    demVotes: 116005,
    repCandidate: "Antonio Swad",
    repVotes: 61494,
    totalVotes: 177499,
    winner: "D"
  },
  {
    state: "Texas",
    district: "33",
    demCandidate: "Marc A Veasey",
    demVotes: 82081,
    repCandidate: "Patrick David Gillespie",
    repVotes: 29203,
    totalVotes: 111284,
    winner: "D"
  },
  {
    state: "Texas",
    district: "34",
    demCandidate: "Vicente Gonzalez",
    demVotes: 70896,
    repCandidate: "Mayra Flores",
    repVotes: 59464,
    totalVotes: 130360,
    winner: "D"
  },
  {
    state: "Texas",
    district: "35",
    demCandidate: "Greg Casar",
    demVotes: 129599,
    repCandidate: "Dan Mcqueen",
    repVotes: 48969,
    totalVotes: 178568,
    winner: "D"
  },
  {
    state: "Texas",
    district: "36",
    demCandidate: "Jon Haire",
    demVotes: 64016,
    repCandidate: "Brian Babin",
    repVotes: 145599,
    totalVotes: 209615,
    winner: "R"
  },
  {
    state: "Texas",
    district: "37",
    demCandidate: "Lloyd Doggett",
    demVotes: 219358,
    repCandidate: "Jenny Garcia Sharon",
    repVotes: 59923,
    totalVotes: 279281,
    winner: "D"
  },
  {
    state: "Texas",
    district: "38",
    demCandidate: "Duncan F Klussmann",
    demVotes: 92302,
    repCandidate: "Wesley Hunt",
    repVotes: 163597,
    totalVotes: 255899,
    winner: "R"
  },
  {
    state: "Utah",
    district: "1",
    demCandidate: "Rick Edwin Jones",
    demVotes: 87986,
    repCandidate: "Blake D Moore",
    repVotes: 178434,
    totalVotes: 266420,
    winner: "R"
  },
  {
    state: "Utah",
    district: "2",
    demCandidate: "Nick Mitchell",
    demVotes: 88224,
    repCandidate: "Chris Stewart",
    repVotes: 154883,
    totalVotes: 243107,
    winner: "R"
  },
  {
    state: "Utah",
    district: "3",
    demCandidate: "Glenn J Wright",
    demVotes: 83687,
    repCandidate: "John R Curtis",
    repVotes: 182497,
    totalVotes: 266184,
    winner: "R"
  },
  {
    state: "Utah",
    district: "4",
    demCandidate: "Darlene McDonald",
    demVotes: 82181,
    repCandidate: "Burgess Owens",
    repVotes: 155110,
    totalVotes: 237291,
    winner: "R"
  },
  {
    state: "Virginia",
    district: "1",
    demCandidate: "Herbert C  Jones, Jr",
    demVotes: 147229,
    repCandidate: "Robert J Wittman",
    repVotes: 191828,
    totalVotes: 339057,
    winner: "R"
  },
  {
    state: "Virginia",
    district: "2",
    demCandidate: "Elaine G Luria",
    demVotes: 143219,
    repCandidate: "Jen A Kiggans",
    repVotes: 153328,
    totalVotes: 296547,
    winner: "R"
  },
  {
    state: "Virginia",
    district: "3",
    demCandidate: "Robert C  Scott",
    demVotes: 139659,
    repCandidate: "Terry T Namkung",
    repVotes: 67668,
    totalVotes: 207327,
    winner: "D"
  },
  {
    state: "Virginia",
    district: "4",
    demCandidate: "A Donald McEachin",
    demVotes: 159044,
    repCandidate: "Leon Benjamin, Sr",
    repVotes: 85503,
    totalVotes: 244547,
    winner: "D"
  },
  {
    state: "Virginia",
    district: "5",
    demCandidate: "Joshua M Throneburg",
    demVotes: 129996,
    repCandidate: "Bob Good",
    repVotes: 177191,
    totalVotes: 307187,
    winner: "R"
  },
  {
    state: "Virginia",
    district: "6",
    demCandidate: "Jennifer Lynn Lewis",
    demVotes: 95410,
    repCandidate: "Ben Cline",
    repVotes: 173352,
    totalVotes: 268762,
    winner: "R"
  },
  {
    state: "Virginia",
    district: "7",
    demCandidate: "Abigail Davis Spanberger",
    demVotes: 143357,
    repCandidate: "Yesli I Vega",
    repVotes: 130586,
    totalVotes: 273943,
    winner: "D"
  },
  {
    state: "Virginia",
    district: "8",
    demCandidate: "Donald S Beyer, Jr",
    demVotes: 197760,
    repCandidate: "Karina A Lipsman",
    repVotes: 66589,
    totalVotes: 264349,
    winner: "D"
  },
  {
    state: "Virginia",
    district: "9",
    demCandidate: "Taysha Lee Devaughan",
    demVotes: 66027,
    repCandidate: "H Morgan Griffith",
    repVotes: 182207,
    totalVotes: 248234,
    winner: "R"
  },
  {
    state: "Virginia",
    district: "10",
    demCandidate: "Jennifer Wexton",
    demVotes: 157405,
    repCandidate: "Hung Cao",
    repVotes: 138163,
    totalVotes: 295568,
    winner: "D"
  },
  {
    state: "Virginia",
    district: "11",
    demCandidate: "Gerald E Connolly",
    demVotes: 193190,
    repCandidate: "James G  Myles",
    repVotes: 95634,
    totalVotes: 288824,
    winner: "D"
  },
  {
    state: "Vermont",
    district: "AL",
    demCandidate: "Becca Balint",
    demVotes: 176494,
    repCandidate: "Liam Madden",
    repVotes: 78397,
    totalVotes: 254891,
    winner: "D"
  },
  {
    state: "Washington",
    district: "1",
    demCandidate: "Suzan K Delbene",
    demVotes: 181992,
    repCandidate: "Vincent J Caveleri",
    repVotes: 104329,
    totalVotes: 286321,
    winner: "D"
  },
  {
    state: "Washington",
    district: "2",
    demCandidate: "Rick Larsen",
    demVotes: 202980,
    repCandidate: "Dan Matthews",
    repVotes: 134335,
    totalVotes: 337315,
    winner: "D"
  },
  {
    state: "Washington",
    district: "3",
    demCandidate: "Marie Gluesenkamp Perez",
    demVotes: 160314,
    repCandidate: "Joe Kent",
    repVotes: 157685,
    totalVotes: 317999,
    winner: "D"
  },
  {
    state: "Washington",
    district: "4",
    demCandidate: "Doug White",
    demVotes: 70710,
    repCandidate: "Dan Newhouse",
    repVotes: 150619,
    totalVotes: 221329,
    winner: "R"
  },
  {
    state: "Washington",
    district: "5",
    demCandidate: "Natasha Hill",
    demVotes: 127585,
    repCandidate: "Cathy Mcmorris Rodgers",
    repVotes: 188648,
    totalVotes: 316233,
    winner: "R"
  },
  {
    state: "Washington",
    district: "6",
    demCandidate: "Derek Kilmer",
    demVotes: 208710,
    repCandidate: "Elizabeth Kreiselmaier",
    repVotes: 138754,
    totalVotes: 347464,
    winner: "D"
  },
  {
    state: "Washington",
    district: "7",
    demCandidate: "Pramila Jayapal",
    demVotes: 295998,
    repCandidate: "Cliff Moon",
    repVotes: 49207,
    totalVotes: 345205,
    winner: "D"
  },
  {
    state: "Washington",
    district: "8",
    demCandidate: "Kim Schrier",
    demVotes: 179003,
    repCandidate: "Matt Larkin",
    repVotes: 155976,
    totalVotes: 334979,
    winner: "D"
  },
  {
    state: "Washington",
    district: "9",
    demCandidate: "Adam Smith",
    demVotes: 171746,
    repCandidate: "Doug Basler",
    repVotes: 67631,
    totalVotes: 239377,
    winner: "D"
  },
  {
    state: "Washington",
    district: "10",
    demCandidate: "Marilyn Strickland",
    demVotes: 152544,
    repCandidate: "Keith R Swank",
    repVotes: 114777,
    totalVotes: 267321,
    winner: "D"
  },
  {
    state: "Wisconsin",
    district: "1",
    demCandidate: "Ann Roe",
    demVotes: 135825,
    repCandidate: "Bryan Steil",
    repVotes: 162610,
    totalVotes: 298435,
    winner: "R"
  },
  {
    state: "Wisconsin",
    district: "2",
    demCandidate: "Mark Pocan",
    demVotes: 268740,
    repCandidate: "Erik Olsen",
    repVotes: 101890,
    totalVotes: 370630,
    winner: "D"
  },
  {
    state: "Wisconsin",
    district: "3",
    demCandidate: "Brad Pfaff",
    demVotes: 152977,
    repCandidate: "Derrick Van Orden",
    repVotes: 164743,
    totalVotes: 317720,
    winner: "R"
  },
  {
    state: "Wisconsin",
    district: "4",
    demCandidate: "Gwen Moore",
    demVotes: 191955,
    repCandidate: "Tim Rogers",
    repVotes: 57660,
    totalVotes: 249615,
    winner: "D"
  },
  {
    state: "Wisconsin",
    district: "5",
    demCandidate: "Mike Van Someren",
    demVotes: 134581,
    repCandidate: "Scott Fitzgerald",
    repVotes: 243741,
    totalVotes: 378322,
    winner: "R"
  },
  {
    state: "Wisconsin",
    district: "6",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Glenn Grothman",
    repVotes: 239231,
    totalVotes: 239231,
    winner: "R"
  },
  {
    state: "Wisconsin",
    district: "7",
    demCandidate: "Richard Dick Ausman",
    demVotes: 128877,
    repCandidate: "Thomas P Tiffany",
    repVotes: 209224,
    totalVotes: 338101,
    winner: "R"
  },
  {
    state: "Wisconsin",
    district: "8",
    demCandidate: "",
    demVotes: 0,
    repCandidate: "Mike Gallagher",
    repVotes: 223981,
    totalVotes: 223981,
    winner: "R"
  },
  {
    state: "West Virginia",
    district: "1",
    demCandidate: "Lacy Watson",
    demVotes: 65428,
    repCandidate: "Carol D Miller",
    repVotes: 151511,
    totalVotes: 216939,
    winner: "R"
  },
  {
    state: "West Virginia",
    district: "2",
    demCandidate: "Barry Lee Wendell",
    demVotes: 84278,
    repCandidate: "Alexander X Mooney",
    repVotes: 160493,
    totalVotes: 244771,
    winner: "R"
  },
  {
    state: "Wyoming",
    district: "AL",
    demCandidate: "Lynnette Greybull",
    demVotes: 47250,
    repCandidate: "Harriet Hageman",
    repVotes: 132206,
    totalVotes: 179456,
    winner: "R"
  },
];

// Helper functions

export const getNationalTotals = () => {
  return houseResults2022.reduce((acc, race) => {
    acc.demVotes += race.demVotes;
    acc.repVotes += race.repVotes;
    acc.otherVotes += race.otherVotes;
    acc.totalVotes += race.totalVotes;
    if (race.winner === 'D') acc.demSeats++;
    if (race.winner === 'R') acc.repSeats++;
    return acc;
  }, { demVotes: 0, repVotes: 0, otherVotes: 0, totalVotes: 0, demSeats: 0, repSeats: 0 });
};

export const getResultsByState = (state) => {
  return houseResults2022.filter(race => 
    race.state.toLowerCase() === state.toLowerCase()
  );
};

export const getStateSummary = (state) => {
  const stateRaces = getResultsByState(state);
  return stateRaces.reduce((acc, race) => {
    acc.demVotes += race.demVotes;
    acc.repVotes += race.repVotes;
    acc.otherVotes += race.otherVotes;
    acc.totalVotes += race.totalVotes;
    if (race.winner === 'D') acc.demSeats++;
    if (race.winner === 'R') acc.repSeats++;
    acc.totalSeats++;
    return acc;
  }, { state, demVotes: 0, repVotes: 0, otherVotes: 0, totalVotes: 0, demSeats: 0, repSeats: 0, totalSeats: 0 });
};

export const getAllStateSummaries = () => {
  const states = [...new Set(houseResults2022.map(r => r.state))];
  return states.map(state => getStateSummary(state)).sort((a, b) => a.state.localeCompare(b.state));
};

export const getClosestRaces = (limit = 10) => {
  return [...houseResults2022]
    .filter(race => race.demVotes > 0 && race.repVotes > 0)
    .map(race => ({
      ...race,
      margin: Math.abs(race.demVotes - race.repVotes),
      marginPercent: Math.abs(race.demVotes - race.repVotes) / race.totalVotes * 100
    }))
    .sort((a, b) => a.margin - b.margin)
    .slice(0, limit);
};

export const getCompetitiveRaces = (marginThreshold = 5) => {
  return houseResults2022
    .filter(race => race.demVotes > 0 && race.repVotes > 0)
    .filter(race => {
      const marginPercent = Math.abs(race.demVotes - race.repVotes) / race.totalVotes * 100;
      return marginPercent <= marginThreshold;
    })
    .map(race => ({
      ...race,
      margin: Math.abs(race.demVotes - race.repVotes),
      marginPercent: Math.abs(race.demVotes - race.repVotes) / race.totalVotes * 100
    }))
    .sort((a, b) => a.marginPercent - b.marginPercent);
};

export const formatDistrict = (state, district) => {
  if (district === 'AL') return `${state} At-Large`;
  return `${state}-${district}`;
};

export const getWinnerInfo = (race) => {
  if (race.winner === 'D') {
    return { name: race.demCandidate, party: 'Democrat', votes: race.demVotes };
  } else if (race.winner === 'R') {
    return { name: race.repCandidate, party: 'Republican', votes: race.repVotes };
  }
  return null;
};